import { Flex } from 'antd';
import styles from './material-code-item.module.css';

interface DropdownItemProps {
  label: React.ReactNode;
}

const MaterialCodeDropdownItem: React.FC<DropdownItemProps> = ({ label }) => {
  const string = label?.toString() || '';
  const segments = string?.split('~');
  return (
    <Flex className={styles.dropdownItem} gap={8} align="center">
      <Flex className={styles.container} gap={8} vertical>
        <div className={styles.caption}>Code {segments[0]}</div>
        <Flex gap={8} justify="space-between">
          <span>ID</span> <span>{segments[1]}</span>
        </Flex>
        <Flex gap={8} justify="space-between">
          <div>Description</div>
          <div className={styles.overflowEllipsis}>{segments[2]}</div>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MaterialCodeDropdownItem;
